<template>
  <b-modal
    id="page-calendar-edit-legend-modal"
    :title="trans('legend')"
    :ok-title="trans('save')"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @ok="onSave"
  >
    <b-row v-for="item in legend" :key="item.variant" class="my-2">
      <b-col v-if="!isCustomLegend(item)" class="col-auto pr-0">
          <b-button
            variant="none"
            size="sm"
            class="mr-2"
            :style="`background-color: ${item.color};`"
            disabled
          >
            <i :class="`fa fa-fw ${isTextOk(item.text) ? 'fa-check' : ''}`"></i>
          </b-button>
        </b-col>
        <b-col v-if="isCustomLegend(item)" class="col-auto pr-0">
          <div
            class="color-picker-container"
            :class="{ 'selected': item.color === item.color }"
            @click="item.color = item.color"
          >
            <color-picker v-model="item.color" @input="updateColor(item, $event)"></color-picker>
          </div>
        </b-col>

        <b-col>
          <b-form-input :ref="item.variant" v-model="item.text" size="sm" />
        </b-col>
    </b-row>
    <b-button
      variant="primary"
      size="sm"
      @click="addLegend"
    >
      + {{ trans('add_custom_legend') }}
    </b-button>
    <b-form-group :label="trans('position')" class="mt-3">
      <b-form-radio-group v-model="legend_position" :options="legend_positions"></b-form-radio-group>
    </b-form-group>
  </b-modal>
</template>

<style>
  #page-calendar-edit-legend-modal .sp-preview-inner{
    border-bottom-right-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-left-radius: 1.25rem;
  }
  #page-calendar-edit-legend-modal .color-picker{
    padding:0px;
  }
</style>
<script>
  import ColorPicker from './../../../common/components/ColorPicker'

  export default {
    props: {
      organization: Object,
      value: Array,
      legendPosition: String,
    },
    components: {
      ColorPicker,
    },
    data() {
      return {
        trans: trans,
        legend: [],
        legend_position: 'bottom',
        legend_positions: [
          {value: 'bottom', text: trans('bottom')},
          {value: 'top', text: trans('top')},
        ],
      }
    },
    computed: {
      serialized() {
        return _.reduce(this.legend, (legend, item) => {
          if (this.isTextOk(item.text)) legend.push(item)
          return legend
        }, [])
      },
    },
    methods: {
      onShown() {
        this.legend = _.map(_.calendarColors, item => {
          let found = _.find(this.value || [], {variant: item.variant})
          return _.assign({text: found ? found.text || null : null}, item)
        })
        const customLegends = _.filter(this.value || [], (item) => {
          return !_.find(_.calendarColors, { variant: item.variant })
        });
        this.legend = [...this.legend, ...customLegends]
        this.legend_position = this.legendPosition || 'bottom'
      },
      isTextOk(text) {
        if (!text || !text.trim()) return false
        return true
      },
      onSave() {
        this.$emit('input', this.serialized)
        this.$emit('legend-position', this.legend_position)
      },
      addLegend() {
        this.legend.push({
          color: '#000000',
          text: '',
        });
      },
      isCustomLegend(item) {
        return !_.find(_.calendarColors, { variant: item.variant })
      },
      updateColor(item, color) {
        item.color = color
      },
    },
    mounted() {
      window.pageCalendarEditLegendModal = this
    },
  }
</script>